import React from "react";
import Pagination, { type PaginationProps } from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import PaginationItem from "@mui/material/PaginationItem";

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  marginRight: 5,
  "&.MuiPaginationItem-page": {
    color: (theme.vars || theme)?.palette?.primary?.main,
    backgroundColor: (theme.vars || theme).palette.action.hover,
    border: 0,
  },
  "&.Mui-selected": {
    backgroundColor: `${(theme.vars || theme)?.palette?.primary?.main}!important`,
    color: `${(theme.vars || theme)?.palette?.primary?.contrastText}!important`,
    border: 0,
  },
}));

const TablePagination = ({
  count = 1,
  page = 1,
  onChange,
  className = "",
  size = "small",
  ...rest
}: PaginationProps & { className?: string }) => {
  return (
    <div className={`chart-pagination my-2 ${className}`}>
      <Pagination
        count={count}
        page={page}
        onChange={onChange}
        size={size}
        boundaryCount={2}
        siblingCount={0}
        color="primary"
        renderItem={(item) => <StyledPaginationItem {...item} />}
        variant="outlined"
        shape="rounded"
        {...rest}
      />
    </div>
  );
};

export default TablePagination;
